document.addEventListener('DOMContentLoaded', () => {
  // Detect if current template is "home-price"
  const isHomePrice =
    document.body.classList.contains('template-home-price') ||
    document.body.dataset.template?.includes('home-price');

  if (!isHomePrice) return;

  const variantSelect = document.querySelector('select[name="id"], #all-product-variants, #ProductSelect');
  if (!variantSelect) return;

  // Look for variants with higher price (A/B test variants)
  const variantWithDash = Array.from(variantSelect.options).find((opt) => {
    const title = opt.textContent.trim();
    const available = !opt.disabled && opt.value !== '';
    const price = parseInt(opt.dataset.price) || 0;
    
    // A/B test variants typically have higher prices
    // Look for variants that contain higher price in the text (e.g., $36.00 vs $34.00)
    const hasHigherPrice = title.includes('$36') || title.includes('$36.00') || price > 3400; // $34.00 = 3400 cents
    
    return available && hasHigherPrice;
  });

  if (variantWithDash) {
    variantSelect.value = variantWithDash.value;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

    // Sync with swatch radios if they exist
    const swatchRadios = document.querySelectorAll('.swatch-variant-value');
    swatchRadios.forEach((radio) => {
      if (radio.value.trim() === variantWithDash.textContent.trim()) {
        radio.checked = true;
      }
    });
  }
});

// Handle dynamic content loading (AJAX navigation, section reloads)
document.addEventListener('shopify:section:load', (event) => {
  // Re-run the auto-selection logic for the loaded section
  const isHomePrice =
    document.body.classList.contains('template-home-price') ||
    document.body.dataset.template?.includes('home-price');

  if (!isHomePrice) return;


  const variantSelect = document.querySelector('select[name="id"], #all-product-variants, #ProductSelect');
  if (!variantSelect) return;

  // Only auto-select if no variant is currently selected
  if (!variantSelect.value || variantSelect.value === '') {
    const variantWithDash = Array.from(variantSelect.options).find((opt) => {
      const title = opt.textContent.trim();
      const available = !opt.disabled && opt.value !== '';
      const price = parseInt(opt.dataset.price) || 0;
      
      // A/B test variants typically have higher prices
      const hasHigherPrice = title.includes('$36') || title.includes('$36.00') || price > 3400;
      
      return available && hasHigherPrice;
    });

    if (variantWithDash) {
      variantSelect.value = variantWithDash.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});

// Handle page navigation events
document.addEventListener('page:load', () => {
  const isHomePrice =
    document.body.classList.contains('template-home-price') ||
    document.body.dataset.template?.includes('home-price');

  if (!isHomePrice) return;


  const variantSelect = document.querySelector('select[name="id"], #all-product-variants, #ProductSelect');
  if (!variantSelect) return;

  // Only auto-select if no variant is currently selected
  if (!variantSelect.value || variantSelect.value === '') {
    const variantWithDash = Array.from(variantSelect.options).find((opt) => {
      const title = opt.textContent.trim();
      const available = !opt.disabled && opt.value !== '';
      const price = parseInt(opt.dataset.price) || 0;
      
      // A/B test variants typically have higher prices
      const hasHigherPrice = title.includes('$36') || title.includes('$36.00') || price > 3400;
      
      return available && hasHigherPrice;
    });

    if (variantWithDash) {
      variantSelect.value = variantWithDash.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});
